$.fn.select2.amd.define(
    'CustomDropdownAdapter',
    [
        'select2/utils',
        'select2/dropdown',
        'select2/dropdown/attachBody',
        'select2/dropdown/search',
        'select2/dropdown/minimumResultsForSearch',
        'select2/dropdown/closeOnSelect',
        'select2/compat/dropdownCss'
    ],
    function(
        Utils,
        Dropdown,
        AttachBody,
        Search,
        MinimumResultsForSearch,
        CloseOnSelect,
        DropdownCSS
    ) {
        var mobileWidth = 895,
            adapter = Utils.Decorate(Dropdown, Search);
        adapter = Utils.Decorate(adapter, MinimumResultsForSearch);
        adapter = Utils.Decorate(adapter, CloseOnSelect);
        adapter = Utils.Decorate(adapter, DropdownCSS);
        adapter = Utils.Decorate(adapter, AttachBody);

        adapter.prototype._positionDropdown = function() {
            this.$dropdown = $(this.$dropdown);
            this.$container = $(this.$container);
            this.$dropdownParent = $(this.$dropdownParent);
            this.$dropdownContainer = $(this.$dropdownContainer);

            if (window.innerWidth < mobileWidth) {
                this.$dropdownContainer.addClass('select-dropdown-container');
                this.$dropdownContainer.css({
                    right: 0,
                    top: '58px',
                    width: '140px',
                    left: 'auto'
                });
                this.$dropdown.css({ width: '140px' });
            } else {
                AttachBody.prototype._positionDropdown.call(this);
            }
        };

        adapter.prototype._resizeDropdown = function() {
            this.$dropdown = $(this.$dropdown);
            this.$container = $(this.$container);
            this.$dropdownParent = $(this.$dropdownParent);
            this.$dropdownContainer = $(this.$dropdownContainer);

            if (window.innerWidth < mobileWidth) {
                this.$dropdown.css({ width: '140px' });
            } else {
                AttachBody.prototype._resizeDropdown.call(this);
            }
        };

        return adapter;
    }
);
